import React from 'react';
import { css } from '@emotion/react';
import { useTranslation } from 'react-i18next';
import { CareRecordButtonGroup } from '../mui/radio/Radio';
import { color } from '../../styles';
import { CareRecordFormHook } from '@/hooks/useCareRecordForm';

interface Props {
  form: CareRecordFormHook;
}

const AlignCenter = css`
  display: flex;
  align-items: center;
`;

const InnerRowContainer = css`
  height: 72px;
`;

const LabelContainer = css`
  display: flex;
  flex-direction: column;
  width: 60px;
  margin: 0 8px 0 0;
`;

const TableIcon = css`
  width: 30px;
  min-width: 30px;
  height: 30px;
  margin: 4px;
`;

const TableLabel = css`
  font-size: 14px;
  color: ${color.dark_gray};
  line-height: 1em;
  flex-shrink: 0;
`;

export const CareRecordUrineToiletRowSection = ({ form }: Props) => {
  const { t } = useTranslation();

  return (
    <div css={[AlignCenter, InnerRowContainer]}>
      <div css={[LabelContainer, AlignCenter]}>
        <img css={TableIcon} src='/images/residents/recordModal/toilet.svg' alt='' />
        <span css={TableLabel}>{t('toilet', 'トイレ')}</span>
      </div>
      <CareRecordButtonGroup
        data={[
          { key: true, value: t('yes', '有') },
          { key: false, value: t('no', '無') },
        ]}
        newValue={form.isUrinatedToilet}
        onChange={form.handleChangeIsUrinatedToilet}
      />
    </div>
  );
};
